import { GoogleOAuthProvider } from "@react-oauth/google";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "./App.css";
import { GOOGLE_OAUTH_CLIENT_ID } from "./constant";
import { AppProvider } from "./helpers/app-context";
import Routes from "./pages/routes";

// Create a client
const queryClient = new QueryClient();

function App() {
  return (
    <GoogleOAuthProvider clientId={GOOGLE_OAUTH_CLIENT_ID}>
      <QueryClientProvider client={queryClient}>
        <AppProvider>
          <div className="flex flex-col h-[100vh] bg-[#F5F4EE]">
            <Routes />
          </div>
        </AppProvider>
      </QueryClientProvider>
    </GoogleOAuthProvider>
  );
}

export default App;
